import { appVersion as generatedVersion } from "./version";

// Centralized app version resolution.
// Prefers the auto-generated version, then env var, then "dev".
export const appVersion: string =
  (generatedVersion as string) ?? process.env.REACT_APP_VERSION ?? "dev";

